export class Storage {

    static storage = window.localStorage;

    static KIOSK_IDENTIFIER = 'kiosk_identifier';
    static KIOSK_MODE = 'kiosk_mode';
    static KIOSK_LANGUAGE = 'kiosk_language';

    static getIdentifier() {
        const code = this.storage.getItem(this.KIOSK_IDENTIFIER);

        if (code === null) {
            return this.createIdentifier();
        }

        return parseInt(code);
    }

    static setIdentifier(code) {
        const cleaned = String(code).replace(/\s+/g, "").trim();

        if (!/^\d+$/.test(cleaned)) {
            return false;
        }

        this.storage.setItem(this.KIOSK_IDENTIFIER, cleaned);
        return true;
    }

    static createIdentifier() {
        const code = Math.floor(Math.random() * 900000000000) + 100000000000;
        this.storage.setItem(this.KIOSK_IDENTIFIER, code);

        return code;
    }

    static getMode() {
        const mode = this.storage.getItem(this.KIOSK_MODE);

        if (mode === null) {
            return 'live';
        }

        return mode;
    }

    static getLanguage() {
        const language = this.storage.getItem(this.KIOSK_LANGUAGE);

        if (language === null) {
            return null;
        }

        return language.trim().toLowerCase() || null;
    }

    static setLanguage(language) {
        const cleaned = String(language || '').trim().toLowerCase();

        if (!cleaned) {
            this.storage.removeItem(this.KIOSK_LANGUAGE);
            return null;
        }

        this.storage.setItem(this.KIOSK_LANGUAGE, cleaned);
        return cleaned;
    }

}
